// extracted by css-extract-rspack-plugin
export default {"logOutput":"unUX8"};